package br.com.vvrefeicoes.portal.core.util

import kotlinx.coroutines.async
import kotlinx.coroutines.awaitAll
import kotlinx.coroutines.coroutineScope
import kotlinx.coroutines.sync.Semaphore
import kotlinx.coroutines.sync.withPermit

/**
 * Executa [transform] para cada item em paralelo, limitando a concorrência a [maxConcurrency].
 * Preserva a ordem dos itens de entrada no resultado.
 */
suspend fun <T, R> Iterable<T>.parallelMap(
    maxConcurrency: Int = 6,
    transform: suspend (T) -> R,
): List<R> =
    coroutineScope {
        val permits = Semaphore(maxConcurrency.coerceAtLeast(1))
        map { item -> async { permits.withPermit { transform(item) } } }.awaitAll()
    }
